import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileSelectDirective } from 'ng2-file-upload';
import { OrderModule } from 'ngx-order-pipe';
import { ToastrModule } from 'ngx-toastr';
import { QuillEditorModule } from 'ngx-quill-editor';


import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { FooterComponent } from './footer/footer.component';
import { GenericService } from './generic.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';



// WellDB
import { FicheEntretienComponent } from './fiche-entretien/fiche-entretien.component';
import { RechercheSimpleComponent } from './recherche-simple/recherche-simple.component';
import { DossierDetailsComponent } from './dossier-details/dossier-details.component';
import { RechercheAvanceeComponent } from './recherche-avancee/recherche-avancee.component';
import { DossierCompetencesComponent } from './dossier-competences/dossier-competences.component';
import { AnnuaireComponent } from './annuaire/annuaire.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DccComponent } from './dcc/dcc.component';
import {DossierService} from './dossier.service';
import {AdminGaurdService} from './gaurds/admin-gaurd.service';
import {AdminManagerGuardService} from './gaurds/admin-manager-guard.service';
import {ConsultantService} from './gaurds/consultant.service';



import { TagInputModule } from 'ngx-chips';
import { SpinnerComponent } from './spinner/spinner.component';
import { AdministrationComponent } from './administration/administration.component';
import { ProfileComponent } from './profile/profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DccConsultantComponent } from './dcc-consultant/dcc-consultant.component';
import { HomeCollaborateurComponent } from './home-collaborateur/home-collaborateur.component';
import { Version } from '@angular/compiler';
import { VersionService } from './version.service';

const appRoutes: Routes = [
{  path : 'login' , component : LoginComponent},

{  path : 'register',     canActivate:[AdminGaurdService],    component : RegisterComponent},  

{  path : 'reset' , component : ResetPasswordComponent},

{  path : 'home', canActivate:[AdminManagerGuardService],  component : HomeComponent},

{  path : 'dcc' , component : DccComponent},

{  path : 'fe' , canActivate:[AdminManagerGuardService],   component : FicheEntretienComponent},

//{  path : 'searchSimple',  canActivate:[AdminManagerGuardService],  component : RechercheSimpleComponent},

{  path : 'dossierDetails', canActivate:[AdminManagerGuardService], component : DossierDetailsComponent,
children: [
  { path: 'dossierDetails?id=dossier.id', canActivate:[AdminManagerGuardService], component : DossierDetailsComponent}
]},

{  path : 'dc' , component : DossierCompetencesComponent},

{  path : 'searchAdvanced', canActivate:[AdminManagerGuardService],  component : RechercheAvanceeComponent},

{  path : 'annuaire' , component : AnnuaireComponent},

{  path : 'administration',  canActivate:[AdminGaurdService],    component : AdministrationComponent},

{  path : 'profile' , component : ProfileComponent},

{  path : 'change' , component : ChangePasswordComponent},

{  path : 'acceuil',  canActivate:[ConsultantService],  component : HomeCollaborateurComponent},

{  path : 'competences', canActivate:[ConsultantService],  component : DccConsultantComponent},

{  path : '', redirectTo : '/login', pathMatch : 'full'},


];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavbarComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    FooterComponent,
    FicheEntretienComponent,
    RechercheSimpleComponent,
    DossierDetailsComponent,
    RechercheAvanceeComponent,
    DossierCompetencesComponent,
    AnnuaireComponent,
    ResetPasswordComponent,
    DccComponent,
    SpinnerComponent,
    AdministrationComponent,
    ProfileComponent,
    ChangePasswordComponent,
    DccConsultantComponent,
    HomeCollaborateurComponent,
   ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    RouterModule.forRoot(appRoutes),
    ToastrModule.forRoot(),
    NgxPaginationModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    TagInputModule,
    OrderModule,
    Ng2SearchPipeModule,
    QuillEditorModule
    ],
  providers: [GenericService, AuthService, DossierService, AdminGaurdService, AdminManagerGuardService, ConsultantService, NotificationService, VersionService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts